import React from "react";

import { Symbol } from "./Symbol";

import "./Logo.scss";

export type LogoProps = {
  cx?: string;
  beta?: boolean;
};

export const Logo: React.FC<LogoProps> = ({ cx = "", beta }) => {
  return (
    <div className={`Logo ${cx}`}>
      <Symbol />
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 119 30"
        className={`Text`}
      >
        <path
          d="M15.4,10c1.7,0,3,0.4,4,1.1c1,0.7,1.5,1.8,1.5,3.3v6c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.5,0.5-0.8,0.6
	c-0.6,0.3-1.2,0.6-1.8,0.7c-0.8,0.2-1.7,0.3-2.5,0.3c-1.7,0-3.1-0.3-4-1S10,20.4,10,19c0-1.1,0.4-2,1.1-2.6c0.7-0.6,1.8-1,3.2-1.1
	l3.5-0.4v-0.5c0-0.6-0.2-1.1-0.7-1.4c-0.5-0.3-1.1-0.5-2-0.5c-0.7,0-1.3,0.1-2,0.2c-0.6,0.1-1.2,0.3-1.7,0.6
	c-0.2-0.1-0.4-0.3-0.5-0.6c-0.1-0.2-0.2-0.5-0.2-0.8c0-0.3,0.1-0.6,0.2-0.8c0.2-0.3,0.5-0.5,0.8-0.6c0.5-0.2,1.1-0.4,1.7-0.5
	C14.1,10.1,14.8,10,15.4,10L15.4,10z M15.5,20.5c0.5,0,0.9,0,1.4-0.1c0.3-0.1,0.6-0.2,0.9-0.3v-2.9l-2.5,0.2c-0.6,0-1.1,0.2-1.6,0.5
	c-0.4,0.2-0.6,0.7-0.5,1.1c0,0.5,0.2,0.9,0.6,1.2C14.1,20.4,14.7,20.5,15.5,20.5L15.5,20.5z M28.2,20c0.4,0.3,0.9,0.4,1.4,0.4
	c0.3,0,0.6,0,0.9-0.1c0.3-0.1,0.5-0.1,0.8-0.3c0.1,0.1,0.3,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.7c0,0.5-0.3,1-0.7,1.3
	c-0.5,0.3-1.2,0.5-2.2,0.5c-1.4,0-2.4-0.3-3.2-0.9c-0.8-0.6-1.2-1.6-1.2-3V7.2c0.1,0,0.3-0.1,0.6-0.1C25.3,7,25.6,7,25.9,7
	c0.6,0,1,0.1,1.3,0.3c0.3,0.2,0.4,0.6,0.4,1.2v2.1h3.8c0.2,0.4,0.3,0.8,0.3,1.3c0,0.4-0.1,0.8-0.3,1c-0.2,0.2-0.5,0.3-0.8,0.3h-3
	v5.6C27.7,19.4,27.8,19.8,28.2,20L28.2,20z M44.1,19.2c0,1.2-0.4,2.1-1.3,2.8c-0.9,0.7-2.2,1-3.9,1c-0.6,0-1.3,0-1.9-0.2
	c-0.5-0.1-1-0.2-1.5-0.5c-0.4-0.2-0.7-0.4-1-0.7c-0.2-0.3-0.3-0.6-0.3-0.9c0-0.3,0.1-0.6,0.2-0.9c0.1-0.2,0.3-0.4,0.6-0.6
	c0.5,0.3,1.1,0.6,1.7,0.8c0.7,0.3,1.4,0.4,2.2,0.4c0.7,0,1.2-0.1,1.6-0.3c0.3-0.2,0.5-0.6,0.5-1c0-0.7-0.5-1.2-1.5-1.4l-1.4-0.3
	c-1.3-0.3-2.2-0.7-2.8-1.3c-0.6-0.6-0.9-1.4-0.9-2.3c0-1.1,0.5-2.1,1.3-2.7c0.9-0.7,2.1-1,3.8-1c0.6,0,1.1,0,1.7,0.1
	c0.5,0.1,0.9,0.2,1.4,0.4c0.3,0.1,0.6,0.4,0.9,0.6c0.2,0.2,0.3,0.5,0.3,0.9c0,0.3-0.1,0.6-0.2,0.8c-0.1,0.2-0.3,0.4-0.5,0.6
	c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.1-0.5-0.2-0.8-0.3c-0.3-0.1-0.6-0.2-1-0.2c-0.3-0.1-0.7-0.1-1-0.1c-0.5,0-1.1,0.1-1.6,0.3
	c-0.3,0.2-0.6,0.5-0.6,0.9c0,0.3,0.1,0.5,0.3,0.7c0.3,0.2,0.7,0.4,1.1,0.5l1.3,0.3c1.4,0.3,2.4,0.8,3.1,1.4
	C43.8,17.4,44.1,18.2,44.1,19.2z M49.7,18c0.2,0.9,0.7,1.5,1.3,1.9c0.7,0.4,1.6,0.6,2.4,0.6c0.7,0,1.4-0.1,2-0.3
	c0.5-0.2,1-0.4,1.5-0.7c0.2,0.1,0.4,0.3,0.6,0.6c0.2,0.2,0.2,0.5,0.2,0.8c0,0.3-0.1,0.7-0.3,0.9c-0.3,0.3-0.6,0.5-1,0.7
	c-0.5,0.2-0.9,0.4-1.4,0.4C54.5,23,53.9,23,53.3,23c-0.9,0-1.9-0.1-2.8-0.4c-0.8-0.3-1.5-0.7-2.1-1.2c-0.6-0.6-1.1-1.3-1.4-2.1
	c-0.3-0.9-0.5-1.9-0.5-2.9c0-0.9,0.1-1.9,0.5-2.8c0.3-0.7,0.7-1.4,1.3-2c0.6-0.5,1.2-0.9,1.9-1.2c0.8-0.3,1.5-0.4,2.3-0.4
	c0.8,0,1.6,0.1,2.3,0.4c0.7,0.2,1.3,0.6,1.8,1.1c0.5,0.5,0.9,1.1,1.2,1.7c0.3,0.7,0.4,1.4,0.4,2.2c0,0.4-0.1,0.8-0.4,1.1
	c-0.3,0.3-0.7,0.4-1,0.5L49.7,18L49.7,18z M52.6,12.5c-0.8,0-1.5,0.3-2.1,0.8c-0.6,0.6-0.9,1.4-1,2.4l5.7-0.9
	c-0.1-0.6-0.3-1.2-0.7-1.7C54.1,12.7,53.4,12.5,52.6,12.5C52.6,12.5,52.6,12.5,52.6,12.5z M68.5,13.1c-0.4-0.3-1-0.5-1.7-0.5
	c-0.5,0-0.9,0.1-1.4,0.2c-0.4,0.1-0.8,0.3-1.1,0.5v9.3c-0.2,0-0.4,0.1-0.6,0.1c-0.3,0.1-0.6,0.1-0.9,0.1c-0.6,0-1-0.1-1.3-0.3
	c-0.3-0.2-0.4-0.6-0.4-1.2V13c0-0.4,0.1-0.7,0.3-1c0.2-0.3,0.5-0.6,0.8-0.7c0.6-0.4,1.3-0.7,2-0.9c0.9-0.2,1.8-0.4,2.7-0.3
	c1.8,0,3.1,0.4,4.1,1.2c1,0.8,1.5,1.9,1.5,3.4v7.9c-0.1,0-0.3,0.1-0.6,0.1c-0.3,0.1-0.6,0.1-0.9,0.1c-0.6,0-1.1-0.1-1.3-0.3
	c-0.3-0.2-0.4-0.6-0.4-1.2v-6.5C69.1,14,68.9,13.5,68.5,13.1L68.5,13.1z M79.7,20c0.4,0.3,0.9,0.4,1.4,0.4c0.3,0,0.6,0,0.9-0.1
	c0.3-0.1,0.5-0.1,0.8-0.3c0.1,0.1,0.3,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.7c0,0.5-0.3,1-0.7,1.3c-0.5,0.3-1.2,0.5-2.2,0.5
	c-1.4,0-2.4-0.3-3.2-0.9c-0.8-0.6-1.2-1.6-1.2-3V7.2c0.1,0,0.3-0.1,0.6-0.1C76.8,7,77.1,7,77.4,7c0.6,0,1,0.1,1.3,0.3
	C79,7.6,79.2,8,79.2,8.5v2.1h3.8c0.1,0.2,0.2,0.4,0.2,0.5c0.1,0.2,0.1,0.5,0.1,0.7c0,0.4-0.1,0.8-0.3,1c-0.2,0.2-0.5,0.3-0.8,0.3h-3
	v5.6C79.2,19.4,79.3,19.8,79.7,20L79.7,20z"
        />
        {!!beta && (
          <path
            d="M95,13h1.5l-0.7,3.5h0c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.1,0.3-0.3,0.4-0.4c0.2-0.1,0.3-0.2,0.5-0.3
	c0.2-0.1,0.4-0.1,0.6-0.1c0.4,0,0.8,0.2,1,0.5c0.2,0.3,0.3,0.7,0.3,1.2c0,0.8-0.1,1.4-0.3,2c-0.2,0.6-0.5,1.1-0.8,1.5
	c-0.3,0.4-0.7,0.7-1.2,0.9c-0.4,0.2-0.9,0.3-1.3,0.3c-0.5,0-0.9,0-1.3-0.1c-0.4-0.1-0.6-0.2-0.8-0.3L95,13z M94.9,20.1
	c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.3,0,0.4,0c0.2,0,0.4-0.1,0.6-0.2c0.2-0.1,0.4-0.3,0.6-0.6c0.2-0.3,0.3-0.6,0.4-0.9
	c0.1-0.4,0.2-0.8,0.2-1.3c0-0.6-0.2-0.8-0.5-0.8c-0.2,0-0.3,0-0.5,0.1c-0.2,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.3,0.3-0.4,0.4
	c-0.1,0.1-0.2,0.3-0.3,0.4L94.9,20.1L94.9,20.1z M105,20.8c-0.3,0.2-0.6,0.4-1,0.5c-0.4,0.1-0.8,0.2-1.4,0.2c-0.6,0-1.2-0.2-1.5-0.6
	c-0.4-0.4-0.6-0.9-0.6-1.6c0-0.6,0.1-1.2,0.3-1.7c0.2-0.5,0.5-1,0.8-1.3c0.3-0.4,0.7-0.6,1.1-0.8c0.4-0.2,0.8-0.3,1.2-0.3
	c0.3,0,0.6,0,0.8,0.1c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0.1,0.3,0.3,0.3,0.5c0.1,0.2,0.1,0.4,0.1,0.6c0,0.3-0.1,0.6-0.3,0.9
	c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0.2-0.7,0.3-1.1,0.4c-0.5,0.1-0.9,0.1-1.4,0.1h-0.2c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.2,0,0.3
	c0,0.1,0,0.1,0,0.2c0,0.4,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3c0.4,0,0.7-0.1,0.9-0.2s0.5-0.2,0.6-0.3L105,20.8L105,20.8z
	 M102.3,17.9c0.2,0,0.5,0,0.7,0c0.3,0,0.5-0.1,0.7-0.1c0.2-0.1,0.4-0.1,0.5-0.3c0.2-0.2,0.3-0.6,0.1-0.8c-0.1-0.1-0.3-0.2-0.6-0.2
	c-0.4,0-0.7,0.1-0.9,0.4C102.6,17.1,102.4,17.5,102.3,17.9L102.3,17.9z M107.6,15.4h0.8l0.2-1.1l1.6-0.4l-0.3,1.6h1.4l-0.3,1.2h-1.4
	l-0.6,2.7c0,0.2-0.1,0.3-0.1,0.5c0,0.2,0,0.3,0.1,0.4c0.1,0.1,0.2,0.1,0.4,0.1c0.2,0,0.3,0,0.4,0c0.1,0,0.3-0.1,0.4-0.2v1.1
	c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3,0.1-0.4,0.1c-0.3,0.1-0.6,0.1-0.9,0.1c-0.4,0-0.7-0.1-0.9-0.3c-0.2-0.2-0.3-0.5-0.3-0.9
	c0-0.1,0-0.2,0-0.3l0-0.3l0.7-3.3h-0.8C107.3,16.6,107.6,15.4,107.6,15.4z M117,19c-0.1,0.3-0.1,0.6-0.1,0.9c0,0.3,0,0.6,0,0.9v0.3
	l0,0.3h-1.1l-0.2-1h0c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.3,0.3-0.5,0.4c-0.2,0.1-0.3,0.2-0.5,0.3c-0.2,0.1-0.4,0.1-0.6,0.1
	c-0.5,0-0.9-0.2-1.2-0.5c-0.2-0.3-0.4-0.8-0.4-1.4c0-0.6,0.1-1.1,0.2-1.7c0.1-0.5,0.4-1,0.7-1.4c0.3-0.4,0.7-0.7,1.2-1
	c0.5-0.2,1-0.4,1.7-0.4c0.3,0,0.6,0,0.9,0.1c0.3,0,0.7,0.1,1,0.2L117,19L117,19z M114.2,20.3c0.1,0,0.3,0,0.4-0.1
	c0.1-0.1,0.2-0.1,0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.2-0.3l0.6-2.8c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0
	c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.4,0.4-0.6,0.7c-0.2,0.3-0.3,0.6-0.3,0.9c-0.1,0.3-0.1,0.7-0.1,1c0,0.3,0,0.5,0.1,0.7
	C113.8,20.2,114,20.3,114.2,20.3z"
          />
        )}
      </svg>
    </div>
  );
};
